import { connect } from "react-redux";
import UCDListing from "./UCDList";
import { bindActionCreators } from "redux";
import {ucdListRequest} from "../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    ucdListResponse : state.CarLoan.ucdListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        ucdListRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UCDListing);